import { render, staticRenderFns } from "./FullPageGuardianDashboard.vue?vue&type=template&id=0090d660&"
import script from "./FullPageGuardianDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPageGuardianDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPageGuardianDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports